import {Row, Col} from 'view-design'
import Util from '@/libs/util';
import styles from './inventory_info.module.less'
export default {
    props: {
        assetOrder:{
            type: Object,
        }
    },
    computed: {
        hasAsset() {
            return !!this.assetOrder.asset
        }
    },
    methods: {
     
    },
    render() {
        const assetOrder = this.assetOrder
        const { asset } = assetOrder
        return <div>
            <Row>
                <Col span="24">有无库存：<span class={styles.value}>{asset ? '有库存' : '无库存，需下单采购'}</span></Col>
                {this.hasAsset && <Col span="6">资产编号：<span class={styles.value}>{asset.uid}</span></Col>}
                {this.hasAsset && <Col span="6">购入价格： <span class={styles.value}>{Util.formattingNumber(asset.price, 2)}</span></Col>}
                {this.hasAsset && <Col span="6">购入年限： <span class={styles.value}>{asset.purchase_date}</span></Col>}
                {!this.hasAsset && <Col span="6">采购价格： <span class={styles.value}>{assetOrder.asset_price ? Util.formattingNumber(assetOrder.asset_price, 2) : '-'}</span></Col>}
                {!this.hasAsset && <Col span="6">预计到货日期： <span class={styles.value}>{assetOrder.expect_arrival_date || '-'}</span></Col>}
            </Row>
        </div>
    }
}